module.exports = __webpack_public_path__ + "d41d8cd98f00b204e9800998ecf8427e.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/public/fonts/Montserrat/Montserrat-LightItalic.ttf
// module id = 1798
// module chunks = 1